import React, { Component } from 'react'
import {
    Spinner,
    Modal,
    ModalHeader,
    ModalBody,
} from "reactstrap";
import UiLoader from "../../../../components/custom/ui-loader";
import Signature from '../../../Signature';
class add extends Component {
    render() {
        return (
            <>
                <Modal
                    backdrop="static"
                    keyboard={false}
                    isOpen={this.props.state.signatureModal}
                    toggle={this.props.toggleSignatureModal}
                    className="modal-dialog-centered modal-lg"
                >
                    <UiLoader
                        blocking={this.props.state.isModalLoadingDisplay}
                        overlayColor="rgba(115, 103, 240, 0.1)"
                        loader={<Spinner color="primary" />}
                    >
                        <ModalHeader toggle={this.props.toggleSignatureModal} className=" bg-primary">
                            Add Signature
                        </ModalHeader>
                        <ModalBody>
                            <Signature
                                state={this.props.state}
                                acceptTNC={this.props.acceptTNC}
                                takeSnapShot={this.props.takeSnapShot}
                                handleSubmitWithSignature={this.props.handleSubmitWithSignature}
                                signatureName={this.props.signatureName}
                                toggleSignatureModal={this.props.toggleSignatureModal}
                                isCart={this.props.isCart}
                            />
                        </ModalBody>
                    </UiLoader>
                </Modal>
            </>
        )
    }
}

export default add
